import {
  Endpoint,
  GetFileDownloadUrlResponse,
  GetFileStatusResponse,
  GetFileUploadUrlQueryParam,
  GetFileUploadUrlResponse,
  VerifyAuthCodeResponse,
} from '../types'
import {
  ApplicationActionPathParams,
  ApplicationFilePathParams,
  ApplicationIdPathParam,
  LoanApplicationResultResponse,
  SecLoansApplicationMetadata,
  SecLoansCreateApplicationRequest,
  SecLoansCreateApplicationResponse,
  SecLoansFileCategory,
  SecLoansGetApplicationResponse,
  SecLoansUpdateApplicationRequest,
  SecLoansUpdateApplicationResponse,
  SecLoansUserInfoResponse,
  SecLoansVerifyAuthCodeRequest,
} from './types'

export const ENDPOINT_SEC_LOANS_GET_USER_INFO: Endpoint<SecLoansUserInfoResponse> = {
  path: '/user-info',
  method: 'get',
}

export const ENDPOINT_CREATE_LOAN_APPLICATION: Endpoint<
  SecLoansCreateApplicationResponse,
  SecLoansCreateApplicationRequest
> = {
  path: '/loan-application',
  method: 'post',
}

export const ENDPOINT_GET_LOAN_APPLICATIONS: Endpoint<SecLoansApplicationMetadata[]> = {
  path: '/loan-applications',
  method: 'get',
}

export const ENDPOINT_GET_LOAN_APPLICATION: Endpoint<
  SecLoansGetApplicationResponse,
  void,
  never,
  ApplicationIdPathParam
> = {
  path: '/loan-application/{applicationId}',
  method: 'get',
}

export const ENDPOINT_GET_LOAN_APPLICATION_PDF: Endpoint<string, void, never, ApplicationIdPathParam> = {
  path: '/loan-application/{applicationId}/pdf',
  method: 'get',
}

export const ENDPOINT_UPDATE_LOAN_APPLICATION: Endpoint<
  SecLoansUpdateApplicationResponse,
  SecLoansUpdateApplicationRequest,
  never,
  ApplicationIdPathParam
> = {
  path: '/loan-application/{applicationId}',
  method: 'put',
}

export const ENDPOINT_LOAN_APPLICATION_ACTION: Endpoint<void, void, never, ApplicationActionPathParams> = {
  path: '/loan-application/{applicationId}/action/{action}',
  method: 'put',
}

export const ENDPOINT_SEC_LOANS_VERIFY_AUTH_CODE: Endpoint<VerifyAuthCodeResponse, SecLoansVerifyAuthCodeRequest> = {
  path: '/verify-auth-code',
  method: 'post',
}

export const ENDPOINT_SEND_LOAN_APPLICATION: Endpoint<
  LoanApplicationResultResponse,
  void,
  never,
  ApplicationIdPathParam
> = {
  path: '/loan-application/{applicationId}',
  method: 'post',
}

export const ENDPOINT_SEC_LOANS_GET_FILE_UPLOAD_URL: Endpoint<
  GetFileUploadUrlResponse,
  void,
  GetFileUploadUrlQueryParam<SecLoansFileCategory>,
  ApplicationIdPathParam
> = {
  path: 'application/{applicationId}/file/upload-url',
  method: 'get',
}

export const ENDPOINT_SEC_LOANS_GET_FILE_UPLOAD_STATUS: Endpoint<
  GetFileStatusResponse,
  void,
  never,
  ApplicationFilePathParams
> = {
  path: 'application/{applicationId}/file/{fileId}/status',
  method: 'get',
}

export const ENDPOINT_SEC_LOANS_DELETE_FILE: Endpoint<void, void, never, ApplicationFilePathParams> = {
  path: 'application/{applicationId}/file/{fileId}',
  method: 'delete',
}

export const ENDPOINT_SEC_LOANS_GET_FILE: Endpoint<GetFileDownloadUrlResponse, void, never, ApplicationFilePathParams> =
  {
    path: 'application/{applicationId}/file/{fileId}',
    method: 'get',
  }
